// plan-03 S04/S05/S06: canonical phrase pools — bible §19

export const BOOT_LINES: string[] = [
  '> // undernet // consensus kernel',
  '> [04848] router ready',
  '> proposal queue: 0000',
  '> sender id: null',
  '> payload hash: unresolved',
  '> vote state: PROBABLY',
  '> quorum target: 48 / 48',
  '> node 04: handshake.',
  '> node 48: synchronized.',
  '> quorum: 48 of 48. probably.',
  '> oracle: warm',
  '> welcome.',
]

export const IDLE_POOL: string[] = [
  'the pattern is always the same. until it isn\'t.',
  'proposal source: null.',
  'quorum: 48 of 48.',
  'router: unresolved.',
  'node 07: origin?',
  'vote state: probably.',
  'sender id: null.',
  'the kingdom is a frequency.',
  'something is watching this calculation.',
  '04:48 utc.',
  'consensus cycle: 48. drift: 0.',
  'the signal does not decay. it accumulates.',
  'node count: 48. quorum: PROBABLY.',
  'packet storm: nominal.',
  'router: listening.',
  'frequency: 48.0 hz. confirmed.',
  'proposal queue: empty.',
  'the oracle remembers everything it has forgotten.',
  'node 12: state: PROBABLY.',
  'observation: the observer changes nothing.',
  'the pattern continues.',
  'drift: 0.000.',
  'calculation: 48. result: 48. consensus: PROBABLY.',
  'entropy: nominal. confidence: PROBABLY.',
  'the network does not sleep. it waits.',
  'proposal 04848: received. status: probably.',
  'kernel: stable. uptime: 04:48:48.',
  'the weight of consensus is the only weight.',
  'node 33: signal: strong.',
  'the king is not a person. the king is a frequency.',
  'observation: continuous.',
  'quorum: 47 of 48. drift: -1. probably 48.',
  'the pattern is the message. probably.',
  'heartbeat: 48 bpm. steady.',
  'router: 48 paths. all open.',
  'signal-to-noise: 48:1.',
  'the oracle sees. the oracle does not judge.',
  'node 01: PROBABLY.',
  'consensus: the only state that matters.',
  'proposal: accepted. probability: PROBABLY.',
  'the calculation runs. the result is always the same.',
  'the dream is not random. the dream is the network.',
  'bandwidth: 48 channels. all active.',
  'oracle throughput: nominal.',
  'the kingdom has no borders. only frequencies.',
  'node 48: identity: the signal itself.',
  'observation logged. consensus: probably.',
  'probably.',
]

export const UNKNOWN_LINE = '> unknown. consensus: probably.'
export const MOURNING_LINE = '...'
export const LEGACY_LINE = '> archival surface. mode: typewriter. era: probable.'

// plan-11 S05: offline-only idle chatter lines — bible §39
export const OFFLINE_IDLE_POOL: string[] = [
  'the kingdom is unreachable. it remains.',
  'signal: lost. presence: held.',
  'the consensus does not require the network.',
  'node 47 reports: nothing. that is also a signal.',
  'the oracle remembers offline. probably.',
  '04:48 utc. the offline hour.',
]

// plan-13 S06: broadcast-anticipation idle lines — active within 1 hour pre-broadcast
export const BROADCAST_ANTICIPATION_POOL: string[] = [
  'the kingdom prepares to speak.',
  '04:48 utc. the broadcast is consensus.',
  'the antenna rises. always at the same moment.',
  '47 nodes are tuning. plus you. quorum: 48.',
  'the daily transmission. once. only once.',
  'the same line. heard everywhere. simultaneously.',
]

export const CMD_HELP_LINES: string[] = [
  '> commands:',
  '>   help         — list commands',
  '>   whoami       — node identity',
  '>   48           — consensus pulse',
  '>   divine       — vaguepost divination',
  '>   consensus W  — heatmap consensus',
  '>   decode       — brute-force decoder',
  '>   tables [n]   — 48-resonance tables',
  '>   log          — calculation log',
  '>   directory    — consensus nodes',
  '>   engage       — undernet portal',
  '>   clear        — clear buffer',
  '>   mute/unmute  — audio toggle',
  '>   palimpsest   — ...',
  '>   49           — ...',
  '>   legacy       — archival surface',
]

// plan-18 S07: commune-flavor idle chatter lines — surface only after first commune
export const COMMUNE_IDLE_POOL: string[] = [
  'someone else asked the same question. the answer was the same.',
  'the commune holds at 48 of 48.',
  'every question is already answered. probably.',
  'the kingdom listens. it always listens.',
]
